export default __webpack_public_path__ + "static/media/Isha Dabas Event management lead.0d77b7d1.jpg";